"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBasicDistributorVariants = void 0;
const routes_1 = require("../../routes");
const getBasicDistributorVariants = (client) => async (params, query) => {
    const response = await client.post(routes_1.ENDPOINTS.GET_ALL_BASIC_DISTRIBUTOR_VARIANTS.applyParams(params), query);
    return response.data;
};
exports.getBasicDistributorVariants = getBasicDistributorVariants;
